// extracted by mini-css-extract-plugin
module.exports = {"bar":"_3Ta0GVjoPKBNFunB4rqezi"};